// Resolve a `public/`-folder asset to an absolute URL.
//
// CRA serves files from `public/` at the app root. JS-side resolution has
// to match that contract from ANY route, not just `/`. The naive approach
// — `new URL("foo.pdf", document.baseURI)` — silently inherits the current
// pathname when there's no `<base>` tag, so visiting `/settings/profile`
// produced URLs like `/settings/foo.pdf` and 404'd.
//
// Two correct sources, in order:
//   1. `process.env.PUBLIC_URL` — CRA substitutes this for any sub-path
//      mounting (the `homepage` field in package.json). Honor it verbatim.
//   2. `window.location.origin` — always points at the host root, so
//      `${origin}/foo.pdf` resolves correctly from any route.
//
// `document.baseURI` is deliberately NOT used; without a `<base>` tag it
// reflects the current document URL and re-introduces the route-inheritance
// bug this utility exists to prevent.
export function resolvePublicAssetUrl(assetPath) {
  const cleaned = String(assetPath || "").replace(/^\/+/, "");
  if (!cleaned) return "/";
  const publicBase = String(process.env.PUBLIC_URL || "").trim();
  if (publicBase) return publicBase.replace(/\/+$/, "") + "/" + cleaned;
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    return window.location.origin + "/" + cleaned;
  }
  return "/" + cleaned;
}
